import React from 'react';
import { Section } from './Section';
import { FlameIcon, ActivityIcon, ZapIcon, BrainIcon, SmileIcon } from 'lucide-react';
const benefits = [{
  icon: <FlameIcon className="w-6 h-6" data-id="element-29" />,
  title: 'Despierta tu metabolismo',
  desc: 'Aprende a combinar alimentos que estimulan la función tiroidea de forma natural, ayudándote a salir del estancamiento.'
}, {
  icon: <ActivityIcon className="w-6 h-6" data-id="element-30" />,
  title: 'Reduce la inflamación',
  desc: 'Incorpora ingredientes antiinflamatorios que alivian la retención de líquidos, la hinchazón y el malestar digestivo.'
}, {
  icon: <ZapIcon className="w-6 h-6" data-id="element-31" />,
  title: 'Multiplica tu energía',
  desc: 'Olvídate de arrastrarte por las mañanas. Cada receta está balanceada para darte vitalidad sostenida durante todo el día.'
}, {
  icon: <BrainIcon className="w-6 h-6" data-id="element-32" />,
  title: 'Recupera tu claridad mental',
  desc: "Nutrientes esenciales como el zinc y el selenio integrados en tus comidas para combatir la 'niebla mental' y mejorar tu enfoque."
}, {
  icon: <SmileIcon className="w-6 h-6" data-id="element-33" />,
  title: 'Vuelve a disfrutar la comida',
  desc: 'Se acabaron las pechugas secas y las ensaladas tristes. Platos tan ricos que no sentirás que estás cuidándote.'
}];
export const Benefits = () => {
  return <Section className="bg-white" data-id="element-34">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-35">
        <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-36">
          Lo que vas a lograr con este plan
        </h2>
        <p className="text-lg text-stone-600" data-id="element-37">
          Pequeños cambios en tu plato, grandes transformaciones en cómo te
          sientes.
        </p>
      </div>

      <div className="max-w-4xl mx-auto space-y-6" data-id="element-38">
        {benefits.map((benefit, idx) => <div key={idx} className="flex flex-col sm:flex-row items-start sm:items-center gap-6 p-6 rounded-2xl bg-stone-50 border border-stone-100 hover:shadow-md transition-shadow" data-id="element-39">
            <div className="w-14 h-14 bg-brand-100 text-brand-700 rounded-full flex items-center justify-center shrink-0" data-id="element-40">
              {benefit.icon}
            </div>
            <div data-id="element-41">
              <h3 className="text-xl font-bold text-stone-900 mb-2" data-id="element-42">
                {benefit.title}
              </h3>
              <p className="text-stone-600 leading-relaxed" data-id="element-43">{benefit.desc}</p>
            </div>
          </div>)}
      </div>
    </Section>;
};